import { REPORTSUMMARY_SUCCESS, REPORTSUMMARY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default reportSummaryReducer;
